export function TribeTaleMark({size = 56}: {size?: number}) {
    const boxSize = size;
    const glyphSize = Math.round(size * (34 / 56)); // ~34 for 56

    return (
        <div style={{
            width: boxSize,
            height: boxSize,
            // Brand badge: fixed teal in BOTH themes (the white pinwheel sits inside it).
            // Not --tt-logo-fill, which inverts to white in dark mode and would hide the mark.
            backgroundColor: '#113139',
            borderRadius: 12,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            alignSelf: 'center'
        }}>
            <svg
                fill="none"
                height={glyphSize}
                viewBox="0 0 24 24"
                width={glyphSize}
                xmlns="http://www.w3.org/2000/svg"
            >
                <path d="M11.7129 3.90332C18.1779 3.90332 23.4254 9.15083 23.4254 15.6159H11.7129V3.90332Z" fill="white" />
                <path d="M11.7129 19.5205C5.24786 19.5205 0.000349045 14.273 0.000349045 7.80797L11.7129 7.80797L11.7129 19.5205Z" fill="white" />
                <path d="M19.5205 11.7124C19.5205 18.1774 14.273 23.4249 7.80797 23.4249V11.7124H19.5205Z" fill="white" opacity="0.5" />
                <path d="M3.9043 11.7124C3.9043 5.24737 9.1518 -0.000139236 15.6168 -0.000139236V11.7124H3.9043Z" fill="white" opacity="0.5" />
            </svg>
        </div>
    );
}
